import { all, call, put, takeLatest } from 'redux-saga/effects';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import { fetchGlobalSearchResults } from '../routines/globalSearchRoutines';

const GLOBAL_SEARCH_BASE_URL = `${envConfig.APIG_URL}core/global-search`;

function* fetchGlobalSearchResultsSaga({ payload }) {
  try {
    const config = {
      method: 'POST',
      payload,
    };
    const url = `${GLOBAL_SEARCH_BASE_URL}/search-temp`; // Todo
    const response = yield call(request, url, config);
    yield put(fetchGlobalSearchResults.success(response.data));
  } catch (error) {
    yield put(fetchGlobalSearchResults.failure({ error }));
  } finally {
    yield put(fetchGlobalSearchResults.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchGlobalSearchResults.TRIGGER, fetchGlobalSearchResultsSaga),
  ]);
}
